module.exports = __webpack_public_path__ + "media/images/lp/img_merit_04-0693c77a801c8d125efec1ae052fd8d1.png";